import React, {useEffect, useState} from "react"
import config from 'config'


export function cancelEMandate() {

    const [name, setName] = useState()
    const [phone, setPhone] = useState()
    const [loanId, setLoanId] = useState()
    const [remarks, setRemarks] = useState()
    const [isLoading, setIsLoading] = useState(false)

    const [checkboxClicked, setCheckboxClicked] = useState(true)

    useEffect(() => {


    }, [name, phone, loanId, remarks])

    function submitFormData() {


        if (!checkboxClicked) {
            window.alert("Please provide the consent")
            return;
        }

        if (!name || !phone || !loanId) {
            window.alert("Name, Phone & LoanID are mandatory")
            return
        }

        setIsLoading(true)

        const requestOptions = {
            method: "POST",
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                "phone": phone,
                "loanId": loanId,
                "name": name,
                "isChecked": checkboxClicked,
                "message": remarks
            })
        }

        console.log("hi requestOptions", requestOptions)

        fetch(`${config.REV_URL}/submitCancelMandateRequest`, requestOptions)
            .then(response => response.json())
            .then(json => {

                if (json.success === true) {
                    window.alert("Dear Customer,\n" +
                        "Thank you for submitting the form. Please note that our customer care team will reach out to you within 3 working days.\n" +
                        "Thanks & Regards\n" +
                        "\n" +
                        "Team Revfin\n" +
                        "care@revfin.in\n" +
                        "+91 8686738738")
                    setIsLoading(false)

                    window.location.replace(window.location.origin)
                }

                if (json.error === true) {
                    window.alert("Please Try after some time")
                    setIsLoading(false)
                }

            })
    }

    return (
        <section className="getIntouch full-w" id="contactus">
            <div className="col" style={{display: "flex", justifyContent: "center"}}>
                <img src={require('../images/logo.png')} className='img-cancel'/>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-4" style={{marginTop: "10px"}}>
                        <b className="getbold fz-35">Request Form to cancel NACH Mandate</b>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <p className="fz-13 mgt-20 textrescenter">Please fill your detail to cancel EMandate</p>
                        <form className="form-inline errohandle" role="form">
                            <div className="full-w">
                                <input type="text" className="mb-2 mr-sm-2 textwidth" name="name" placeholder="Name*"
                                       onChange={(e) => setName(e.target.value)} required/>
                                <div className="full-w error"></div>
                            </div>
                            <div className="full-w myflex f-between form-group">
                                <div className="half-w">
                                    <input type="number" className="mb-2 mr-sm-2 textwidth" name="mobile_number"
                                           placeholder="Mobile Number*" maxLength="10"
                                           onChange={(e) => setPhone(e.target.value)} required/>
                                    <div className="full-w error"></div>
                                </div>
                                <div className="half-w">
                                    <input type="text" className="mb-2 mr-sm-2 textwidth" name="email"
                                           placeholder="Loan ID*"
                                           onChange={(e) => setLoanId(e.target.value)} required/>
                                    <div className="full-w error"></div>
                                </div>
                            </div>

                            <div className="full-w">
                            <textarea className="full-w textwidth" rows="5" name="message" placeholder="Your Message"
                                      onChange={(e) => setRemarks(e.target.value)}/>
                                <div className="full-w error"></div>
                            </div>
                            <div className="full-w" style={{marginTop: "30px", marginBottom: "20px"}}>
                                <div className="row">
                                    <div className="col-1" style={{marginRight: "10px"}}>
                                        <input type="checkbox" checked={checkboxClicked}
                                               onClick={() => setCheckboxClicked(!checkboxClicked)}
                                               style={{height: "20px", width: "20px"}}/>
                                    </div>
                                    <div className="col-10" style={{padding: "0"}}>
                                        <p>
                                            I, customer having the loan ID mentioned above, want to submit the claim for
                                            mandate cancellation. I hereby declare that the above information is true,
                                            complete & correct to the best of my knowledge and belief.
                                        </p>
                                    </div>
                                </div>
                            </div>


                            <div className="full-w myflex f-between flex-center"
                                 style={{display: "flex", justifyContent: "center"}}>
                                <button type="button" className="btn submitbutton mb-2" disabled={isLoading}
                                        onClick={submitFormData}>{isLoading ? "Submitting" : "Submit"}</button>
                            </div>
                            <div className="full-w" style={{marginTop: "10px"}}>
                                <font color='#585858'>Note: Fields marked with * are mandatory</font>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}



// WEBPACK FOOTER //
// ./src/components/cancelEMandate.js